/**
 * EMIS/LESMIS Student Profile Validator
 * ກວດສອບ field ທີ່ຈຳເປັນຕາມມາດຕະຖານ EMIS-LESMIS StudentProfile
 */

export const EMIS_ENROLLMENT_STATUS = {
  1: 'ນັກຮຽນໃໝ່ (ບໍ່ທັນໄດ້ລົງທະບຽນຢູ່ໃສ)',
  2: 'ເສັງໄດ້/ເລື່ອນຂັ້ນ (ພາຍໃນລະດັບ)',
  3: 'ເສັງໄດ້/ເລື່ອນຊັ້ນ (ຂ້າມລະດັບ)',
  4: 'ປະລະ ແລ້ວມາເຂົ້າຮຽນຄືນ',
  5: 'ຍ້າຍມາຈາກໂຮງຮຽນອື່ນ',
};

export const EMIS_DISABILITY = {
  1: 'ມີ',
  2: 'ບໍ່ມີ',
  3: 'ບໍ່ແນ່ໃຈ',
};

export const EMIS_DISABILITY_TYPE = {
  1: 'ດ້ານການໄດ້ຍິນ ແລະ ການປາກເວົ້າ',
  2: 'ດ້ານການເບິ່ງເຫັນ',
  3: 'ດ້ານຮ່າງກາຍ',
  4: 'ດ້ານສະຕິປັນຍາ',
  5: 'ດ້ານຄວາມຈື່ຈຳ',
  6: 'ດ້ານອື່ນໆ (ຊ້ຳຊ້ອນ)',
};

export const EMIS_ETHNICITY = {
  1: 'ລາວ', 2: 'ໄຕ', 3: 'ຜູ້ໄທ', 4: 'ລື້', 5: 'ຍວນ',
  6: 'ຢັ້ງ', 7: 'ແຊກ', 8: 'ໄທເໜືອ',
  9: 'ກຶມມຸ', 10: 'ໄປຣ', 11: 'ຊີງມູນ', 12: 'ຜ້ອງ', 13: 'ແທ່ນ',
  14: 'ເອີດູ', 15: 'ບິດ', 16: 'ລະເມດ', 17: 'ສາມຕ່າວ', 18: 'ກະຕາງ',
  19: 'ມະກອງ', 20: 'ຕຣີ', 21: 'ຢຣູ', 22: 'ຕຣຽງ', 23: 'ຕະໂອ້ຍ',
  24: 'ແຢະ', 25: 'ເບຣົາ', 26: 'ກະຕູ', 27: 'ຮາຣັກ', 28: 'ໂອຍ',
  29: 'ກຣຽງ', 30: 'ເຈັງ', 31: 'ສະດາງ', 32: 'ຊ່ວຍ', 33: 'ຍະເຫີນ',
  34: 'ລະວີ', 35: 'ປະໂກະ', 36: 'ຂະແມ', 37: 'ຕຸ້ມ', 38: 'ງວນ',
  39: 'ມ້ອຍ', 40: 'ກຣີ',
  41: 'ມົ້ງ', 42: 'ອີ້ວມຽນ',
  43: 'ອາຄາ', 44: 'ພູນ້ອຍ', 45: 'ລາຫູ', 46: 'ສີລາ', 47: 'ຮາຢີ',
  48: 'ໂລໂລ', 49: 'ຫໍ້',
  50: 'ອື່ນໆ (ໄດ້ຮັບສັນຊາດລາວ)', 51: 'ຕ່າງດ້າວ',
};

export const EMIS_GRADE_CODE = {
  1: 'ລ້ຽງເດັກອ່ອນ', 2: 'ລ້ຽງເດັກກາງ', 3: 'ລ້ຽງເດັກໃຫຍ່',
  4: 'ອນ1', 5: 'ອນ2', 6: 'ອນ3',
  7: 'ກຸ່ມຮຽນຜ່ານການຫຼິ້ນ', 8: 'ຫຼັກສູດ 10 ອາທິດ',
  9: 'ປ1', 10: 'ປ2', 11: 'ປ3', 12: 'ປ4', 13: 'ປ5', 14: 'ປ6',
  15: 'ມ1', 16: 'ມ2', 17: 'ມ3', 18: 'ມ4', 19: 'ມ5', 20: 'ມ6', 21: 'ມ7',
  22: 'ປະຖົມບຳລຸງ ລ.1-2', 23: 'ປະຖົມບຳລຸງ ລ.3',
  24: 'ມ.ຕ.ຕົ້ນ ບຳລຸງ', 25: 'ມ.ຕ.ປາຍ ບຳລຸງ', 26: 'ອື່ນໆ',
};

/**
 * ກວດສອບ field ຕ່າງໆ ຂອງ EMIS StudentProfile
 * @param {Object} student - ຂໍ້ມູນນັກຮຽນ
 * @returns {{ valid: boolean, errors: Object, warnings: string[] }}
 */
export function validateEmisStudent(student) {
  const errors = {};
  const warnings = [];

  // ---- ຂໍ້ມູນພື້ນຖານ ----
  if (!student.firstNameLao) errors.firstNameLao = 'ຕ້ອງປ້ອນຊື່ (ລາວ)';
  if (!student.familyNameLao) errors.familyNameLao = 'ຕ້ອງປ້ອນນາມສະກຸນ (ລາວ)';
  if (!student.dob) errors.dob = 'ຕ້ອງລະບຸວັນເດືອນປີເກີດ';
  if (!student.gender) errors.gender = 'ຕ້ອງລະບຸເພດ';
  if (!student.Grade_Code) errors.Grade_Code = 'ຕ້ອງລະບຸຊັ້ນຮຽນ';
  else if (!EMIS_GRADE_CODE[student.Grade_Code]) warnings.push(`ລະຫັດຊັ້ນຮຽນ ${student.Grade_Code} ບໍ່ຢູ່ໃນລາຍຊື່ EMIS (1-26)`);

  // ---- EMIS-specific fields ----
  if (!student.enrollment_status) {
    errors.enrollment_status = 'ຕ້ອງລະບຸສະຖານະພາບການລົງທະບຽນ (Q.32)';
  } else if (![1, 2, 3, 4, 5].includes(Number(student.enrollment_status))) {
    errors.enrollment_status = 'ລະຫັດສະຖານະ (Q.32) ຕ້ອງເປັນ 1-5';
  }

  if (!student.ethnicity_code) {
    errors.ethnicity_code = 'ຕ້ອງລະບຸຊົນເຜົ່າ (Q.34)';
  } else if (!EMIS_ETHNICITY[Number(student.ethnicity_code)]) {
    errors.ethnicity_code = 'ລະຫັດຊົນເຜົ່າ (Q.34) ຕ້ອງເປັນ 1-51';
  }

  if (!student.disability) {
    errors.disability = 'ຕ້ອງລະບຸຄວາມພິການ (Q.35)';
  } else if (![1, 2, 3].includes(Number(student.disability))) {
    errors.disability = 'ລະຫັດຄວາມພິການ (Q.35) ຕ້ອງເປັນ 1, 2, ຫຼື 3';
  }

  // ຖ້າ disability=1 (ມີ) ຕ້ອງລະບຸປະເພດ
  if (Number(student.disability) === 1) {
    if (!student.disability_type) {
      errors.disability_type = 'ເມື່ອ Q.35=1 ຕ້ອງລະບຸປະເພດຄວາມພິການ (Q.36)';
    } else if (![1, 2, 3, 4, 5, 6].includes(Number(student.disability_type))) {
      errors.disability_type = 'ລະຫັດປະເພດຄວາມພິການ (Q.36) ຕ້ອງເປັນ 1-6';
    }
  }

  // ---- ຄຳເຕືອນ (warning) ----
  if (!student.avatar_base64) warnings.push('ຍັງບໍ່ໄດ້ອັບໂຫຼດຮູບພາບ');
  if (!student.cur_prov_id) warnings.push('ຍັງບໍ່ໄດ້ລະບຸທີ່ຢູ່ປັດຈຸບັນ');
  if (!student.b_prov_id) warnings.push('ຍັງບໍ່ໄດ້ລະບຸທີ່ຢູ່ບ້ານເກີດ');

  return {
    valid: Object.keys(errors).length === 0,
    errors,
    warnings,
  };
}

/**
 * ກວດສອບ array ຂອງນັກຮຽນ ແລ້ວ return ສະຫຼຸບ
 * @param {Array} students
 * @returns {{ total: number, valid: number, invalid: number, report: Array }}
 */
export function bulkValidateEmis(students) {
  const report = students.map((s, i) => {
    const result = validateEmisStudent(s);
    return {
      index: i + 1,
      student_id: s.student_id,
      name: `${s.firstNameLao || ''} ${s.familyNameLao || ''}`.trim(),
      ...result,
    };
  });

  return {
    total: students.length,
    valid: report.filter(r => r.valid).length,
    invalid: report.filter(r => !r.valid).length,
    report,
  };
}
